import React from 'react';
const MentionCard = ({ title, url, prettyDate }) => (React.createElement("div", { className: "grid-column" },
    React.createElement("a", { href: url, className: "card-uni", "data-aos": "animated", target: "_blank", rel: "noreferrer" },
        React.createElement("div", { className: "card-uni__content" },
            React.createElement("div", { className: "card-uni__content-top" },
                React.createElement("div", { className: "card-uni__date" }, prettyDate),
                React.createElement("div", { className: "card-uni__open-in-new-tab" },
                    React.createElement("svg", { width: "32", height: "32", viewBox: "0 0 32 32" },
                        React.createElement("use", { href: "/src/img/svg/icon-open-in-new-tab.svg#icon-open-in-new-tab" })))),
            React.createElement("h4", { className: "card-uni__title" }, title)))));
export default MentionCard;
